// src/api/dhammaAgent.js

// IMPORTANT: Replace this with the exact base URL from your Cloud Run service.
// Based on your screenshot, it looks like this:
const API_BASE_URL = 'https://dhamma-ai-agent-406072157152.us-central1.run.app'; // Corrected Base URL

export const getDhammaResponse = async (query) => {
  try {
    // The correct endpoint path as shown in your curl request is /chat/invoke
    const response = await fetch(`${API_BASE_URL}/chat/invoke`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      // Your AI agent expects 'message' and 'session_id', not just 'query'
      body: JSON.stringify({ message: query, session_id: "default_session" }), // Corrected body structure
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("AI Agent Error Response:", errorText); // Log the full error from AI agent
      throw new Error(`HTTP error! Status: ${response.status}. Message: ${errorText || 'Unknown error'}`);
    }

    const data = await response.json();
    // Assuming the AI agent's response structure has a 'response' field (as seen in your curl output)
    return data.response;
  } catch (error) {
    console.error("Error calling Dhamma AI Agent:", error);
    throw new Error("Failed to get response from AI agent. Please check the network connection or server status.");
  }
};